import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import { Fade } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { SetSplashOpen } from '../../store/features/splash';
import splashThumb from '../../assets/splash_thumb.png';

export default function OpenScreen() {
  let time;
  const storageURL = process.env.REACT_APP_Stroage_URL;
  const dispatch = useDispatch();
  const { splash_open } = useSelector(store => store.splash);
  const videoRef = useRef(null);
  const [showPlayBtn, setShowPlayBtn] = useState(false);
  const [showSkipBtn, setShowSkipBtn] = useState(false);
  const [text, setText] = useState('4s后关闭');

  const splashItem = useSelector((store) => {
    let arr = store.splash.data;
    if (arr && arr.length > 0) {
      let target = arr.find(e => {
        return e.name && e.name.substr(0, 2) == '开屏';
      });
      return target || null;
    }
    return null;
  });

  const hasVideo = !!(splashItem && splashItem.video);
  const posterSrc = splashThumb;

  const closeHandler = () => {
    dispatch(SetSplashOpen(false));
    clearInterval(time);
  };

  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) {
      throw new Error('开屏视频节点不存在');
    }
    setShowPlayBtn(false);
    setShowSkipBtn(true);
    video.play().catch((err) => {
      console.error('开屏视频播放失败', err);
      setShowPlayBtn(true);
      setShowSkipBtn(false);
    });
  };

  useEffect(() => {
    if (!splash_open) {
      return;
    }

    if (hasVideo) {
      setShowPlayBtn(true);
      setShowSkipBtn(false);
      setText('跳过');
      return;
    }

    setShowSkipBtn(true);
    let t = 4;
    setText(t + 's后关闭');
    time = setInterval(() => {
      t--;
      setText(t + 's后关闭');
      if (t == 0) {
        closeHandler();
      }
    }, 1000);

    return () => clearInterval(time);
  }, [splash_open, hasVideo]);

  useEffect(() => {
    if (!splash_open) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, [splash_open]);

  return (
    <Fade in={splash_open}>
      <Box sx={{ position: 'fixed', left: 0, top: 0, zIndex: 999999, width: '100%', height: '100%', overflow: 'hidden', backgroundColor: '#000' }}>
        {!hasVideo && showSkipBtn && (
          <Button
            variant="contained"
            onClick={closeHandler}
            sx={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              zIndex: 10,
              minWidth: 'auto',
              px: 1.5,
              py: 0.5,
              bgcolor: 'rgba(0,0,0,0.45)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.7)',
              borderRadius: '16px',
              fontSize: '13px',
              boxShadow: 'none',
              '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
            }}
          >
            {text}
          </Button>
        )}
        {hasVideo ? (
          <Box sx={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
            {showSkipBtn && (
              <Button
                variant="contained"
                onClick={closeHandler}
                sx={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  zIndex: 10,
                  minWidth: 'auto',
                  px: 1.5,
                  py: 0.5,
                  bgcolor: 'rgba(0,0,0,0.45)',
                  color: '#fff',
                  border: '1px solid rgba(255,255,255,0.7)',
                  borderRadius: '16px',
                  fontSize: '13px',
                  boxShadow: 'none',
                  '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
                }}
              >
                跳过
              </Button>
            )}
            <video
              ref={videoRef}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', border: 'none' }}
              src={storageURL + splashItem.video}
              playsInline
              preload="auto"
              poster={posterSrc}
              onEnded={closeHandler}
            />
            {showPlayBtn && (
              <Box
                onClick={handlePlay}
                sx={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 72,
                  height: 72,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(0,0,0,0.55)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 3,
                  cursor: 'pointer',
                }}
              >
                <PlayArrowIcon sx={{ fontSize: 48, color: '#fff' }} />
              </Box>
            )}
          </Box>
        ) : (
          <img style={{ width: '100vw', height: '100vh', objectFit: 'cover', border: 'none', display: 'block' }} src={posterSrc} alt="" />
        )}
      </Box>
    </Fade>
  );
}
